module.exports = __webpack_public_path__ + "img/pic01.edd38c88.png";